<template>
  <div class="contain">
    <div style="margin: 3rem 0 1rem">
      第 1 步，共 3 步 | Step 1 , Total 3 steps
    </div>
    <div
      style="
        font-size: 2rem;
        line-height: 2rem;
        font-weight: bold;
        color: #b62d2e;
        text-align: center;
      "
    >
      建立家長帳戶<br />Create Parent Account
    </div>
    <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #b62d2e;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #de5934;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #f1aa55;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
    </div>
    <div class="col-xs-22 col-sm-13" style="text-align: center">
      完成註冊流程後，<br />
      我們會透過電子郵件將家長平台密碼傳送給您。<br />
      After completing the registration,<br />
      we will send the login password via email.
    </div>
    <!-- <div style="margin-bottom: 1.675rem;">Enter your email and we’ll send you instructions to reset your password</div> -->
    <div class="security-box">
      <el-form ref="form" :model="form" style="margin-top: 2rem" :rules="rules">
        <el-form-item prop="email">
          <div class="security-title">家長電郵 Parent's Email</div>
          <el-input
            @input="inputChange"
            v-model="form.email"
            placeholder="家長電郵/Parent’s Email"
          >
          </el-input>
          <div
            v-if="isExist"
            style="line-height: 1.6; font-size: 14px; color: #d20000"
          >
            該電郵已被註冊 The email has been registered
          </div>
        </el-form-item>
        <el-form-item prop="name">
          <div class="security-title">家長姓名 Parent's Name</div>
          <el-input v-model="form.name" placeholder="家長姓名/Parent's Name">
          </el-input>
        </el-form-item>
<!--        <div id="grecaptcha" style="margin-top: 1.5rem"></div>-->
      </el-form>
      <div style="display: flex; flex-direction: column; margin-top: 1rem">
        <el-button round @click="onJoin" class="security-button"
          >註冊 Registration</el-button
        >
        <div
          style="text-align: center; color: #444444; padding: 1.25rem 1.25rem 0"
        >
          我同意 MathConcept Online
          <span
            @click="$router.push({ name: 'disclaimer' })"
            style="color: #0000ff; cursor: pointer"
            >使用條款</span
          >
          及
          <span
            @click="$router.push({ name: 'privacy' })"
            style="color: #0000ff; cursor: pointer"
            >隱私政策。</span
          >
          <br />
          I agree to the MathConcept Online
          <span
            @click="$router.push({ name: 'disclaimer' })"
            style="color: #0000ff; cursor: pointer"
            >Terms of Service</span
          >
          and
          <span
            @click="$router.push({ name: 'privacy' })"
            style="color: #0000ff; cursor: pointer"
            >Privacy Policy.</span
          >
          <el-divider style="padding: 0 1rem"></el-divider>
        </div>
        <div style="text-align: center; color: #444444">
          已有帳戶？ Already have an account?
        </div>
        <el-button round @click="onBackText" class="security-button"
          >登入 Login</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { searchUser } from "@/api/user";
import { recaptcha } from "@/api/security";
export default {
  data() {
    var validateEmail = (rule, value, callback) => {
      if (
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
          value
        )
      ) {
        callback();
      } else {
        callback(
          new Error(
            "電郵地址格式不正確。The format of the e-mail address is incorrect."
          )
        );
      }
    };
    return {
      isExist: false,
      form: {
        name: null,
        email: null,
      },
      recaptchaResult: false,
      rules: {
        email: [
          {
            required: true,
            message: "請輸入電郵地址 Please enter an e-mail address",
            trigger: "blur",
          },
          { validator: validateEmail, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: "請輸入家長姓名 Please enter parent's name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // let that = this;
    // let intervalId = setInterval(function () {
    //   if (window.grecaptcha) {
    //     that.initial();
    //     clearInterval(intervalId);
    //     return;
    //   }
    // }, 500);
  },
  methods: {
    initial() {
      window.grecaptcha.render("grecaptcha", {
        // sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',//test 6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe
        sitekey: "6LdaEQIoAAAAAM7p77HXb8V3dZN1yZiVNedP_UjE",
        hl: this.$store.getters.language == "en" ? "en" : "zh-HK",
        callback: this.submit,
      });
    },
    inputChange() {
      this.isExist = false;
    },
    submit(token) {
      recaptcha({ token }).then((v) => {
        this.recaptchaResult = v.data.success;
      });
    },
    onJoin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          searchUser({ email: this.form.email }).then((v) => {
            if (v.data > 0){
              this.isExist = true;
            }else{
              this.$router.push({
                name: "subscribe",
                query: {
                  name: this.form.name,
                  email: this.form.email,
                  needSubscribe: true,
                },
              });
            }
          });
        } else {
          return false;
        }
      });
      // 有验证的注册
      // if (this.recaptchaResult) {
      //   this.$refs.form.validate((valid) => {
      //     if (valid) {
      //       searchUser({ email: this.form.email }).then((v) => {
      //         if (v.data.length > 0) this.isExist = true;
      //         else
      //           this.$router.push({
      //             name: "subscribe",
      //             query: {
      //               name: this.form.name,
      //               email: this.form.email,
      //               needSubscribe: true,
      //             },
      //           });
      //       });
      //     } else {
      //       return false;
      //     }
      //   });
      // } else {
      //   this.$message.error('You did not enter the correct captcha response. Please try again');
      //   window.grecaptcha.reset();
      // }
    },
    onBackText() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  //padding:0 60px;
  flex: 1;
}
.security-box {
  width: 43rem;
}
.security-title {
  color: #8e8e8e;
  font-weight: bold;
  line-height: 1.6rem;
}
.security-button {
  margin: 1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  font-size: 1.125rem;
  color: #444444;
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .security-box {
    width: 27rem;
  }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain {
    height: 100%;
  }
  .security-box {
    width: 20rem;
    max-width: 90vw;
  }
}
::v-deep {
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .el-input-group__prepend {
    border-top-left-radius: 3.125rem;
    border-bottom-left-radius: 3.125rem;
    background-color: #fffbed;
    border: 0.0625rem solid #fffbed;
    padding: 0 1.25rem;
    padding-right: 0;
  }
  .el-form-item__error {
    font-size: 14px;
    line-height: 1.6;
    padding-top: 0;
  }
  .el-input__icon {
    width: 1.75rem;
    line-height: 2.75rem;
  }
  .el-icon-circle-close {
    font-size: 1.75rem;
  }
  .el-icon-circle-check {
    color: #008000;
    font-size: 1.75rem;
  }
  .el-button + .el-button {
    margin: 0;
    margin-top: 1.125rem;
  }
  .security-button:nth-child(1) {
    background-color: #fcc03a;
  }
  .security-button:nth-last-child(1) {
    background-color: #ffffff;
  }
}
</style>